import $ from 'jquery';
import 'bootstrap';
window.jQuery = $; 
window.jquery = $; 
window.$ = $;